import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import React from "react";
import { degrees, PDFDocument, rgb, StandardFonts, download } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { Button, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Loader from "react-loader-spinner";
import { serverApi, globalApi, parseDate } from "../../../../../global/globalFunctions";
import {
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Row,
    Col,
    Collapse,
    CustomInput,
    Card,
    ModalBody,
    ModalFooter,
    Modal,
} from "reactstrap";
import {
    getStates,
    getFormData
} from "../../profileInformation/profileInformation.actions";
import { getFormData as petitionerGetAllData } from "../../PetitionerPacket.actions";
import {
    petitionerCheck,
    isMilitaryMember,
    numberPagesAttached,
    respondentAppears,
    finalDeclarationsWaive,
    amendPetition,
    eventHappened,
    filingCompeleting,
    dissolvingMarriage,
    haveMinorChild,
    haveSpousalSupport,
    changeFormerName,
    postJudgementForm,
    getJudgementFormData
} from "./judgementPacketForms.actions";
import { isEmpty, isNumber, remove, omit, filter, size, isUndefined } from "lodash";
import { IndeterminateCheckBoxOutlined } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

const JudgmentPacketForms = (props) => {

    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;
    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);







    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const [isJudgeOne, setJudgeOne] = useState(props.IsRespondentAppears.respondentAppearsStatus);
    const [isJudgeTwo, setJudgetwo] = useState(props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus == 1 ? 1 : -1);
    const [isJudgeThree, setJudgeThree] = useState(props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus == 1 ? 1 : -1);
    const [isJudgeFour, setJudgeFour] = useState(props.whatEventHappnedFirst.eventHappnedFirstStatus == "1" ? 1 : props.whatEventHappnedFirst.eventHappnedFirstStatus == "0" ? 0 : -1);
    const [isJudgeFive, setJudgeFive] = useState(false);
    const [isJudgeSix, setJudgeSix] = useState(props.haveMinorChildren == "1" ? 1 : -1);
    const [isJudgeSeven, setJudgeSeven] = useState(props.bornPriorMarriage.childBornBeforeStatus == "1" ? 1 : props.bornPriorMarriage.childBornBeforeStatus == "0" ? 0 : "-1");
    const [isJudgeEight, setJudgeEight] = useState(props.bornPriorMarriage.completeOneStatus == 1 ? 1 : -1);
    const [isJudge, setJudge] = useState(props.existingCourtOrder.courtCustodyCaseStatus == 1 ? 1 : -1);
    const [isJudgeNine, setJudgeNine] = useState(props.childEnforced.enforcedInOtherCaseStatus == 1 ? 1 : props.childEnforced.enforcedInOtherCaseStatus == 0 ? 0 : -1);
    const [isJudgeTen, setJudgeTen] = useState(props.childEnforced.enforcedInOtherCaseNo.selectionStatus == 1 ? 1 : -1);
    const [isJudgeEleven, setJudgeEleven] = useState(false);
    const [isJudgeTwelve, setJudgeTwelve] = useState(false);
    const [isJudgeThirdteen, setJudgeThirdteen] = useState(props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus == 1 ? 1 : -1);
    const [isGetStart, setGetStart] = useState(false);
    const [isMilitaryServices, setMilitaryServices] = useState(false);
    const [isLegalProfessional, setLegalProfessional] = useState(props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementNo.legalProfessionalStatus == 1 ? 1 : -1);
    const [isFinalDec, setFinalDec] = useState(false);
    const [isSpouseAmend, setSpouseAmend] = useState(false);
    const [isFillComplete, setFillComplete] = useState(false);
    const [isAnyInfo, setAnyInfo] = useState(false);
    const [isSpouse, setSpouse] = useState(false);
    const [isPublicAssistance, setPublicAssistance] = useState(false);
    const [isJudgeFourteen, setJudgeFourteen] = useState(false);
    const [isJudgeFiveteen, setJudgeFiveteen] = useState(false);
    const [isJudgeSixteen, setJudgeSixteen] = useState(false);
    const [isJudgeSeventeen, setJudgeSeventeen] = useState(false);
    const [isJudgeEightteen, setJudgeEightteen] = useState(false);
    const [isJudgeNineteen, setJudgeNineteen] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [show, setShow] = useState(false);
    const [neverSelect, setSelect] = useState(false);
    const [ID, setID] = useState(false);
    const [isFilling, setFilling] = useState(0);

    useEffect(() => {

        props.petitionerGetAllData();
        props.getJudgementFormData({
            divorce_id: window.localStorage.getItem("divorce_id"),
        });
        props.postJudgementForm({
            divorce_id: window.localStorage.getItem("divorce_id"),
        });
        props.getStates();
        !isEmpty(window.localStorage.getItem("divorce_id")) && props.getFormData({
            divorce_id: window.localStorage.getItem("divorce_id"),
        });
    }, []);

    async function printFL130() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-130`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();

        const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
        const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);

        form.getCheckBox("partiesAgree").check();
        form.getCheckBox("asvApprove").check();

        if (props.profilePetitionerCheck == 0) {
            !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
            !isUndefined(petitionerDetails) && form.getField("streetAddress").setText(petitionerDetails.streetAddress);
            !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);
            !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
            !isUndefined(petitionerDetails) && form.getField("zipCode").setText(petitionerDetails.zip);
            !isUndefined(petitionerDetails) && form.getField("telePhone").setText(petitionerDetails.telephone.toString());
            !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
        } else {
            !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`)
            !isUndefined(respondentDetails) && form.getField("streetAddress").setText(respondentDetails.streetAddress);
            !isUndefined(respondentDetails) && form.getField("city").setText(respondentDetails.city);
            !isEmpty(resState) && form.getField("state").setText(resState[0].state_name);
            !isUndefined(respondentDetails) && form.getField("zipCode").setText(respondentDetails.zip);
            !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone.toString());
            !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
        }

        !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
        !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
        !isUndefined(courtDetails) && form.getField("cityZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
        !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
        !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);

        !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(petitionerDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("asvCaseNumber").setText(courtDetails.caseNumber.toString());

        if (props.isSpouseMilitaryMember == 1) {
            form.getCheckBox("partiesWaive").check();
            form.getCheckBox("asvMatter").check();
            form.getCheckBox("partiesAgreement").check();
            form.getCheckBox("arForm").check();
        } else {
            form.getCheckBox("partiesWaive").uncheck();
            form.getCheckBox("asvMatter").uncheck();
            form.getCheckBox("partiesAgreement").uncheck();
            form.getCheckBox("arForm").uncheck();
        }




        if (props.IsRespondentAppears.respondentAppearsStatus == 1) {
            form.getCheckBox("arPrev").check();
            form.getCheckBox("partiesWaive").check();
            form.getCheckBox("asvMatter").check();
            form.getCheckBox("partiesAgreement").check();
            form.getCheckBox("partiesAgree").check();
            form.getCheckBox("asvApprove").check();
        } else {
            form.getCheckBox("arPrev").uncheck();
            form.getCheckBox("partiesWaive").uncheck();
            form.getCheckBox("asvMatter").uncheck();
            form.getCheckBox("partiesAgreement").uncheck();
            form.getCheckBox("partiesAgree").uncheck();
            form.getCheckBox("asvApprove").uncheck();
        }



        !isUndefined(petitionerDetails) && form.getField("asvCaseNumber1").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(respondentDetails) && form.getField("asvCaseNumber2").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }

    async function printFL130A() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-130(A)`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());


        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();


        form.getCheckBox("maritalAgreement").check();

        !isUndefined(respondentDetails) && form.getField("civilName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

        form.getField("CaseNumber").setText(courtDetails.caseNumber.toString());
        !isUndefined(respondentDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);

        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }



    async function printFL144() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-144`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());


        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();



        if (props.profilePetitionerCheck == 0) {
            !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);
            !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
            !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
        } else {
            !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);
            !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
            !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
        }

        form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
        !isUndefined(respondentDetails) && form.getField("petitioner").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(petitionerDetails) && form.getField("respondent").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);


        !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
        !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
        !isUndefined(courtDetails) && form.getField("city").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
        !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
        !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);

        !isUndefined(petitionerDetails) && form.getField("nameP").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
        !isUndefined(respondentDetails) && form.getField("nameR").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);


        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }


    async function printFL170() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-170`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);

        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();


        form.getCheckBox("sjOther").check();
        form.getField("sjSpec").setText("As agreed to in the Marital Settlement Agreement, attached to the Judgment, FL-180")


        const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
        const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);

        if (props.profilePetitionerCheck == 0) {

            !isUndefined(petitionerDetails) && form.getField("sjName").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
            !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`)
            !isUndefined(petitionerDetails) && form.getField("streetAddress").setText(petitionerDetails.streetAddress);
            !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);
            !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
            !isUndefined(petitionerDetails) && form.getField("zipCode").setText(petitionerDetails.zip);
            !isUndefined(petitionerDetails) && form.getField("telePhone").setText(petitionerDetails.telephone.toString());
            !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
        } else {
            !isUndefined(respondentDetails) && form.getField("sjName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`)
            !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`)
            !isUndefined(respondentDetails) && form.getField("streetAddress").setText(respondentDetails.streetAddress);
            !isUndefined(respondentDetails) && form.getField("city").setText(respondentDetails.city);
            !isEmpty(resState) && form.getField("state").setText(resState[0].state_name);
            !isUndefined(respondentDetails) && form.getField("zipCode").setText(respondentDetails.zip);
            !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone.toString());
            !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
        }




        !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
        !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
        !isUndefined(courtDetails) && form.getField("cityZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
        !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
        !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);

        !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(respondentDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("dduCaseNumber").setText(courtDetails.caseNumber.toString());

        !isUndefined(petitionerDetails) && form.getField("dduPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(respondentDetails) && form.getField("dduRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("dduCaseNum").setText(courtDetails.caseNumber.toString());

        !isUndefined(petitionerDetails) && form.getField("spfPetName").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(respondentDetails) && form.getField("spfResName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("spfCaseNumber").setText(courtDetails.caseNumber.toString());

        form.getCheckBox("spfSpousal").check();
        form.getCheckBox("spfAgreement").check();

        if (props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus == 1) {
            form.getCheckBox("dduDefault").check();
            form.getCheckBox("dduFinal").check();

        } else {
            form.getCheckBox("dduDefault").uncheck();
            form.getCheckBox("dduFinal").uncheck();

        }

        if (props.isSpouseMilitaryMember == "1" || props.IsRespondentAppears.respondentAppearsStatus == 1 || props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus == 1 || props.whichFiling == 1) {
            form.getCheckBox("dduUncontested").check();
        } else {
            form.getCheckBox("dduUncontested").uncheck();
            form.getCheckBox("dduDefault").check();
        }

        if (props.underAge18Child.no.underAge18Status == 1) {
            form.getCheckBox("dduCustody").check();
            form.getCheckBox("dduInfo").check();
            form.getCheckBox("dduHasNot").check();
            form.getCheckBox("dduVisit").check();
            form.getField("dduVisitSpec").setText("As agreed to in the Marital Settlement Agreement, attached to the Judgment, FL-180.");
            form.getCheckBox("dduChildSupport").check();

        } else {
            form.getCheckBox("dduCustody").uncheck();
            form.getCheckBox("dduInfo").uncheck();
            form.getCheckBox("dduHasNot").uncheck();
            form.getCheckBox("dduVisit").uncheck();
            form.getField("dduVisitSpec").setText(" ");
            form.getCheckBox("dduChildSupport").uncheck();
        }


        if (props.childEnforced.enforcedInOtherCaseStatus == 1) {
            form.getCheckBox("dduChildSupport").check();
            form.getCheckBox("dduEnforced").check();
            form.getField("dduEnforcedCounty").setText(props.childEnforced.enforcedInOtherCaseYes.county);
            form.getField("dduEnforcedSpec").setText(props.childEnforced.enforcedInOtherCaseYes.caseNumber);
        } else if (props.childEnforced.enforcedInOtherCaseStatus == 0) {
            form.getCheckBox("dduChildSupport").check();
            if (props.childEnforced.enforcedInOtherCaseNo.selectionStatus == 0) {
                form.getCheckBox("dduKnowledge").check();
            } else if (props.childEnforced.enforcedInOtherCaseNo.selectionStatus == 1) {
                form.getCheckBox("dduRequest").check();
                form.getField("dduOrderSpec").setText(props.childEnforced.enforcedInOtherCaseNo.selectionNo.provideFacts);
                if (props.childEnforced.enforcedInOtherCaseNo.selectionNo.spouseStatus == 0) {
                    form.getCheckBox("dduReqPetitionor").check();
                } else if (props.childEnforced.enforcedInOtherCaseNo.selectionNo.spouseStatus == 1) {
                    form.getCheckBox("dduReqRespondent").check();
                }
            }
        }




        if (props.publicAssitance.publicAssitanceFirstStatus == 0) {
            form.getCheckBox("dduReceive").check();
        } else if (props.publicAssitance.publicAssitanceFirstStatus == 1) {
            form.getCheckBox("dduNotReceiving").check();
        } else if (props.publicAssitance.publicAssitanceFirstStatus == 2) {
            form.getCheckBox("dduApply").check();
        }

        if (props.publicAssitance.publicAssitanceSecondStatus == 0) {
            form.getCheckBox("dduParty").check();
        } else if (props.publicAssitance.publicAssitanceSecondStatus == 1) {
            form.getCheckBox("dduPartyNot").check();
        }

        if (props.publicAssitance.publicAssitanceThird == 0) {
            form.getCheckBox("partyPetitioner").check();
        } else if (props.publicAssitance.publicAssitanceThird == 1) {
            form.getCheckBox("partyRespondent").check();
        }


        if (props.isChangeFormerName.changeFormerNameStatus == 1) {
            props.isChangeFormerName.changeFormerNameYes.isSpouseStatus == 0 ? form.getCheckBox("afPetitioner").check() : form.getCheckBox("afRespondent").check()
        }

        if (props.whichFilingOption == 0) {
            form.getCheckBox("dduDissolution").check()
        } else {
            form.getCheckBox("dduLegal").check()
        }
        props.isFinalDeclarations == 1 ? form.getCheckBox("dduStipulation").check() : form.getCheckBox("dduExpense").check()
        if (props.isAmendPetition == 1) {
            form.getCheckBox("dduAmended").check()
            form.getCheckBox("dduPetition").check()
        } else {
            form.getCheckBox("dduPetition").check()
        }

        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");

    }

    async function printFL180() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-180`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);

        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();



        form.getCheckBox("familyCode").check();
        form.getCheckBox("pdoAttach").check();
        form.getCheckBox("sasjudge").check();

        form.getCheckBox("ijOther").check();

        form.getField("ifOtherSpec").setText("as agreed to in the attached Marital Settlement Agreement, and incorporated herein.")


        const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
        const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);


        if (props.whichFilingOption == 0) {
            form.getCheckBox("jDissolution").check();

        } else if (props.whichFilingOption == 1) {
            form.getCheckBox("legalSep").check();

        } else if (props.whichFilingOption == 2) {
            form.getCheckBox("jNullity").check();
        }
        else {
            form.getCheckBox("jDissolution").uncheck();
            form.getCheckBox("legalSep").uncheck();
            form.getCheckBox("jNullity").uncheck();
        }




        if (props.profilePetitionerCheck == 0) {
            !isUndefined(petitionerDetails) && form.getField("telePhone").setText(petitionerDetails.telephone.toString());
            !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
            !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);

        } else {
            !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone.toString());
            !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
            !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);

        }

        !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
        !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
        !isUndefined(courtDetails) && form.getField("cityZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
        !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
        !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);


        !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(petitionerDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("jCaseNumber").setText(courtDetails.caseNumber.toString());

        !isUndefined(courtDetails) && form.getField("caseNum").setText(courtDetails.caseNumber.toString());

        form.getCheckBox("sdpOrder").check();
        form.getCheckBox("sasjAgreement").check();

        if (props.isDissolveMarriage.dissolveMarriageStatus != -1 && props.whichFilingOption == 0) {

            moment(props.isDissolveMarriage.sixMonth.sixMonthDate).isValid() && form.getField("dateMarital").setText(parseDate(props.isDissolveMarriage.sixMonth.sixMonthDate));
        }
        // else if (props.isDissolveMarriage.dissolveMarriageStatus == 1 && props.whichFilingOption == 0) {
        //     form.getField("dateMarital").setText("Date Judgment Filed")
        // } 
        else if (props.isDissolveMarriage.dissolveMarriageStatus == -1 && props.whichFilingOption == 1) {
            form.getField("dateMarital").setText("");
        }
        else {
            form.getField("dateMarital").setText("");
        }

        if (props.isChangeFormerName.changeFormerNameStatus == 1) {
            if (props.isChangeFormerName.changeFormerNameYes.isSpouseStatus == 0) {
                form.getCheckBox("cogPet").check()
                !isEmpty(props.isChangeFormerName.changeFormerNameYes.name) && form.getField("cogSpecify").setText(props.isChangeFormerName.changeFormerNameYes.name)

            } else {
                form.getCheckBox("cogRes").check()
                !isEmpty(props.isChangeFormerName.changeFormerNameYes.name) && form.getField("cogSpecify").setText(props.isChangeFormerName.changeFormerNameYes.name)

            }
        }

        if (props.whatEventHappnedFirst.eventHappnedFirstStatus == 1) {
            form.getCheckBox("resAppeared").check();
            moment(props.whatEventHappnedFirst.respondentAppears.respondentAppearenceDate).isValid() && form.getField("cajDate").setText(props.whatEventHappnedFirst.respondentAppears.respondentAppearenceDate == "1947-01-01" ? "" : parseDate(props.whatEventHappnedFirst.respondentAppears.respondentAppearenceDate))

        } else if (props.whatEventHappnedFirst.eventHappnedFirstStatus == 0) {
            form.getCheckBox("rwsProcess").check();
            moment(props.whatEventHappnedFirst.respondentAppears.respondentServedDate).isValid() && form.getField("cajDate").setText(props.whatEventHappnedFirst.respondentServed.respondentServedDate == "1947-01-01" ? "" : parseDate(props.whatEventHappnedFirst.respondentServed.respondentServedDate))
        } else {
            form.getCheckBox("resAppeared").uncheck();
            form.getField("cajDate").setText("")
            form.getCheckBox("rwsProcess").uncheck();
            form.getField("cajDate").setText("");
        }

        if (props.whichFilingOption == 0) {
            form.getCheckBox("SinglePerson").check();
        } else if (props.whichFilingOption == 1) {
            form.getCheckBox("judgmentLegal").check();
        } else if (props.whichFilingOption == 2) {
            form.getCheckBox("judgmentNullity").check();
        } else {
            form.getCheckBox("SinglePerson").uncheck();
            form.getCheckBox("judgmentLegal").uncheck();
            form.getCheckBox("judgmentNullity").uncheck();

        }
        if (props.underAge18Child.no.underAge18Status == 1) {
            form.getCheckBox("childSupport").check();
            form.getCheckBox("domesticPart").check();
            form.getCheckBox("childCustody").check();
            form.getCheckBox("settlementAgreement").check();
            form.getCheckBox("childSupportOrder").check();
            form.getCheckBox("sasJudgment").check();
        } else {
            form.getCheckBox("childSupport").uncheck();
            form.getCheckBox("domesticPart").uncheck();
            form.getCheckBox("childCustody").uncheck();
            form.getCheckBox("settlementAgreement").uncheck();
            form.getCheckBox("childSupportOrder").uncheck();
            form.getCheckBox("sasJudgment").uncheck();
        }

        const namesArray = [];
        const dobArray = [];


        !isEmpty(props.underAge18Child.yes.childInfo) && props.underAge18Child.yes.childInfo.map((child) => {
            namesArray.push(`${child.first_name}` + " " + `${child.last_name}`);
            dobArray.push(`${child.dob}`);
        });
        const childNames = namesArray.join(",");
        const childDob = dobArray.join(",");

        if (props.bornPriorMarriage.childBornBeforeStatus == 1) {
            form.getCheckBox("bornPrior").check();
        }

        if (form.getCheckBox("domesticPart").isChecked()) {
            form.getField("dpNameSpec").setText(childNames);
            form.getField("dpBirthday").setText(childDob);
            form.getCheckBox("dpName").check();
            // form.getCheckBox("bornPrior").check();
        } else {
            form.getField("dpNameSpec").setText("");
            form.getField("dpBirthday").setText("");
            form.getCheckBox("dpName").uncheck();
            // form.getCheckBox("bornPrior").uncheck();
        }


        form.getField("IjName").setText(props.number_pages_attached);

        if (form.getCheckBox("SinglePerson").isChecked()) {
            form.getCheckBox("cogSpec").check();
            moment(props.isDissolveMarriage.sixMonth.sixMonthDate).isValid() && form.getField("cogSpecDate").setText(parseDate(props.isDissolveMarriage.sixMonth.sixMonthDate));
        } else {
            form.getCheckBox("cogSpec").uncheck();
            form.getField("cogSpecDate").setText("");
        }

        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }

    async function printFL190() {
        const existingPdfBytes = await fetch(`${serverApi}/FL-190`, {
            headers: {
                Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
            },
        }).then((res) => res.arrayBuffer());

        var bytes = new Uint8Array(existingPdfBytes);
        const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
        const form = pdfDoc.getForm();



        const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
        const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);


        !isUndefined(petitionerDetails) && form.getField("nejInfo1").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}` + `\n` + `${petitionerDetails.telephone}`);
        !isUndefined(respondentDetails) && form.getField("nejInfo2").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}` + `\n` + `${respondentDetails.telephone}`);



        if (props.profilePetitionerCheck == 0) {
            !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}` + `\n` + `${petitionerDetails.streetAddress}` + `\n` + `${petitionerDetails.city}` + `,` + `${petState[0].state_name}` + ` ` + `${petitionerDetails.zip}`);
            !isUndefined(petitionerDetails) && form.getField("telePhone").setText(petitionerDetails.telephone.toString());
            !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);

        } else {
            !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);
            !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone.toString());
            !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);

        }

        !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
        !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
        !isUndefined(courtDetails) && form.getField("cityZip").setText(courtDetails.city);
        !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
        !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);

        !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
        !isUndefined(respondentDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
        !isUndefined(courtDetails) && form.getField("nejCaseNumber").setText(courtDetails.caseNumber.toString());

        if (props.isDissolveMarriage.dissolveMarriageStatus != -1 && props.whichFilingOption == 0) {
            moment(props.isDissolveMarriage.sixMonth.sixMonthDate).isValid() && form.getField("domesticStatus").setText(parseDate(props.isDissolveMarriage.sixMonth.sixMonthDate))
        } else {
            form.getField("domesticStatus").setText("");
        }
        form.getField("nejDate").setText(parseDate(props.isDissolveMarriage.sixMonth.sixMonthDate));

        if (props.whichFilingOption == 0) {
            form.getCheckBox("nejDissoliution").check()
        } else if (props.whichFilingOption == 1) {
            form.getCheckBox("nejDissoliutionLegal").check()
        } else {
            form.getCheckBox("nejDissoliutionNullity").check()
        }


        // form.flatten();
        const pdfBytes = await pdfDoc.save();
        const pdfDataUrl = URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" })
          );
          window.open(pdfDataUrl, "_blank");
    }
    function saveByteArray(reportName, byte) {
        var blob = new Blob([byte], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }

    const handlePostFunc = () => {
        if (activeStep == 0) {
            props.isMilitaryMember({
                divorce_id: window.localStorage.getItem("divorce_id"),
                isRespondent: document.getElementById("militaryMember").value,
            });

        }
        else if (activeStep == 1) {
            props.respondentAppears({
                divorce_id: window.localStorage.getItem("divorce_id"),
                respondentFilled: document.getElementById("respondentAppearenceStatus").value,
                respondentAppearance: document.getElementById("respondentAppearenceStatus").value == 0 ? document.getElementById("divorcePurposeStatus").value : -1,
                startInterview: document.getElementById("divorcePurposeStatus").value == 0 ? document.getElementById("startOverInterviewStatus").value : -1,
                respondentSettlement: document.getElementById("startOverInterviewStatus").value == 0 ? document.getElementById("settlementAgreementStatus").value : -1,
                interview: document.getElementById("settlementAgreementStatus").value == 0 ? document.getElementById("legalProfessionalStatus").value : -1,
            });

        }
        else if (activeStep == 2) {
            props.finalDeclarationsWaive({
                divorce_id: window.localStorage.getItem("divorce_id"),
                finalDeclarations: document.getElementById("finalDeclarations").value,
            });

        } else if (activeStep == 3) {
            props.amendPetition({
                divorce_id: window.localStorage.getItem("divorce_id"),
                spouseAmendPettition: document.getElementById("amendPetition").value,
            });
        } else if (activeStep == 4) {
            props.eventHappened({
                divorce_id: window.localStorage.getItem("divorce_id"),
                eventStatus: document.getElementById("eventStatus").value,
                respondentServedDate: document.getElementById("eventStatus").value == 0 && document.getElementById("respondentServedDate").value != "" ? moment(document.getElementById("respondentServedDate").value).format('YYYY-MM-DD') : "",
                respondentAppearsDate: document.getElementById("eventStatus").value == 1 && document.getElementById("respondentAppearsDate").value != "" ? moment(document.getElementById("respondentAppearsDate").value).format('YYYY-MM-DD') : "",
            });
        } else if (activeStep == 5) {
            props.filingCompeleting({
                divorce_id: window.localStorage.getItem("divorce_id"),
                filling_complete: document.getElementById("filingStatus").value == 1 ?
                    ((setActiveStep((prevActiveStep) => prevActiveStep == 5 && prevActiveStep + 1)), 1) :
                    document.getElementById("filingStatus").value == 2 ?
                        ((setActiveStep((prevActiveStep) => prevActiveStep == 5 && prevActiveStep + 1)), 2) : document.getElementById("filingStatus").value,
            });
        } else if (activeStep == 6) {
            props.dissolvingMarriage({
                divorce_id: window.localStorage.getItem("divorce_id"),
                statusDivorce: document.getElementById("dissolveMarriageStatus").value,
                enterDate: document.getElementById("sixMonthDate").value
            });
        }
        else if (activeStep == 7) {
            props.haveMinorChild({
                divorce_id: window.localStorage.getItem("divorce_id"),
                minor_children_agreement: document.getElementById("minor_children_agreement").value,

                prior_mirrage: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("prior_mirrage").value : "-1",
                child_new_information: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("prior_mirrage").value == 1 ? document.getElementById("selectAndComplete").value : "-1",
                county: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("prior_mirrage").value == 1 && document.getElementById("selectAndComplete").value == 1 ? document.getElementById("selectAndCompleteCounty").value : "",
                case_number: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("prior_mirrage").value == 1 && document.getElementById("selectAndComplete").value == 1 ? document.getElementById("selectAndCompleteCase").value : "",
                information_entered_uccjea: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("prior_mirrage").value == 0 ? document.getElementById("UCCJEA").value : "-1",

                existing_court_order_custody: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("existingCourtOrder").value : "-1",
                existing_court: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("existingCourtOrder").value == 1 ? document.getElementById("existingCourtOrderCourt").value : "",
                existing_county: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("existingCourtOrder").value == 1 ? document.getElementById("existingCourtOrderCounty").value : "",
                existing_case_number: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("existingCourtOrder").value == 1 ? document.getElementById("existingCourtOrderCase").value : "",

                child_support_enforce: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("childSupportEnforced").value : "-1",
                child_support_court: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 1 ? document.getElementById("childSupportEnforcedCourt").value : "",
                child_support_county: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 1 ? document.getElementById("childSupportEnforcedCounty").value : "",
                child_support_case_number: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 1 ? document.getElementById("childSupportEnforcedCase").value : "",
                select_one: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 0 ? document.getElementById("select_one").value : "-1",
                your_spouse: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 0 && document.getElementById("select_one").value == 1 ? document.getElementById("your_spouse").value : "-1",
                spouse_earning_ability: document.getElementById("minor_children_agreement").value == 1 && document.getElementById("childSupportEnforced").value == 0 && document.getElementById("select_one").value == 1 ? document.getElementById("spouse_earning_ability").value : "",

                public_assistance: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("public_assistance").value : "-1",
                best_my_knowledge: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("best_my_knowledge").value : "-1",
                party_receiving: document.getElementById("minor_children_agreement").value == 1 ? document.getElementById("party_receiving").value : "-1",
            })
        }
        else if (activeStep == 8) {
            props.changeFormerName({
                divorce_id: window.localStorage.getItem("divorce_id"),
                yesNo: document.getElementById("changeFormerNameStatus").value,
                petiRes: document.getElementById("changeFormerNameStatus").value == 1 ? document.getElementById("isSpouseStatus").value : 0,
                lastname: document.getElementById("changeFormerNameStatus").value == 1 ? document.getElementById("formerLastName").value : 0,
            });

        } else if (activeStep == 9) {
            props.numberPagesAttached({
                divorce_id: window.localStorage.getItem("divorce_id"),
                number_pages_attached: document.getElementById("pagesAttached").value,
            });
        }
    }
    const handleShow = () => {
        setShow(true)
    }
    const handleClose = () => setShow(false);
    const handleChange = (value) => {
        if (value == 1) {
            setJudgeThree(JSON.parse(value))
            handleClose()
        } else {
            handleShow()
            setJudgeThree(JSON.parse(value))
        }

    }

    function getSteps() {
        return [
            'Is the Respondent (you or your spouse) a member of the military services for the U.S.?',
            'Was a Response filed or did the Respondent make an appearance?',
            'You and your spouse must complete a second set of disclosures called the Final Declarations of Disclosure. Or, you have the option to waive these if you update your Preliminary Disclosures. You complete both the Preliminary and Final in Step 2 of the program.',
            'Did you or your spouse amend the Petition?',
            'We need to know which happened first: Respondent was served with the Petition Packet or Respondent made an appearance in the divorce. Appearance is a legal term for taking an action, like filing a Response Packet.',
            'Which filing are you completing?',
            'When will your status dissolve?',
            'Do you have minor children that are part of this Agreement?',
            'Do either you or your spouse want to change your name to your former name?',
            'How many pages will you be attaching to your Judgment?',
        ];
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        {/* Q2 Started */}
                        <FormGroup>
                            <Label for="militaryMember">
                                <Typography variant="h5"></Typography>
                            </Label>
                            <Input
                                defaultValue={props.isSpouseMilitaryMember}
                                type="select"
                                name="militaryMember"
                                id="militaryMember"
                            >
                                <option selected value="-1">
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value={0}>No</option>
                                <option value={1}>Yes</option>
                            </Input>
                        </FormGroup>
                    </div>
                );
            case 1:
                return (
                    <div>
                        {/* Q3 Started */}
                        <FormGroup style={{ marginBottom: "0px" }}>
                            <Alert style={{
                                backgroundColor: "#f0fbfb",
                                color: "black"
                            }} icon={false} severity="warning"><b>Hint:</b> Appearance is a legal term for taking an action, like filing a Response Packet or appearing at a hearing.  If Respondent paid the court filing fee/or got a fee waiver, Respondent has made an appearance. </Alert>
                        </FormGroup>
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect">
                                    <Typography variant="h5"></Typography>
                                </Label>
                                <Input
                                    defaultValue={props.IsRespondentAppears.respondentAppearsStatus}
                                    type="select"
                                    name="married"
                                    id="respondentAppearenceStatus"
                                    onChange={(e) => (setJudgeOne(e.target.value))}

                                >

                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value={0} selected={props.IsRespondentAppears.respondentAppearsStatus == 0}>No, Respondent did not file forms with the court or make an appearance (and didn’t pay the court filing fee).</option>
                                    <option value={1} selected={props.IsRespondentAppears.respondentAppearsStatus == 1}>Yes, Respondent filed forms with the court or made an appearance (and paid filing fee/filing fee waived).</option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isJudgeOne == "0" ? true : false}>
                            <FormGroup>
                                <h5>Will the Respondent (you or your spouse) want to make “an appearance” for the purposes of the divorce? </h5>
                                <Input
                                    defaultValue={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus}
                                    type="select"
                                    name="married"
                                    id="divorcePurposeStatus"
                                    onChange={(e) => setJudgetwo(e.target.value)}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value={0} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus == 0}>No, the Respondent will still not make an appearance.</option>
                                    <option value={1} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus == 1}>Yes, the Respondent will make an appearance with these final divorce papers. </option>
                                </Input>
                            </FormGroup>

                            <Collapse isOpen={isJudgeTwo == "1" ? true : false}>
                                <FormGroup style={{ marginTop: "0px" }}>
                                    <Alert style={{
                                        backgroundColor: "yellow",
                                        color: "black"
                                    }} icon={false} severity="warning"> Make sure to include the Respondent's filing fee when you submit your Judgment packet to the court. </Alert>
                                </FormGroup>
                            </Collapse>
                            <Collapse isOpen={isJudgeTwo == 0 ? true : false}>
                                <div style={{ marginBottom: "30px" }}>
                                    <FormGroup>
                                        <h5>Do you want to start this interview over? </h5>
                                        <Input
                                            defaultValue={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewStatus}
                                            type="select"
                                            name="married"
                                            id="startOverInterviewStatus"
                                            onChange={(e) => handleChange(e.target.value)}
                                        >
                                            <option selected value="-1">
                                                {" "}
                                                -- Select an option --{" "}
                                            </option>
                                            <option value={0} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewStatus == 0}>No, that’s correct. I am doing a default divorce.</option>
                                            <option value={1} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewStatus == 1}>Yes</option>
                                        </Input>
                                    </FormGroup>
                                </div>


                                <Collapse isOpen={isJudgeThree == "0" ? true : false}>
                                    <div style={{ marginBottom: "30px" }}>
                                        <FormGroup>
                                            <h5>Will the Respondent sign a settlement agreement like an MSA?  Respondent’s signature must be notarized. </h5>
                                            <Input
                                                defaultValue={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus}
                                                type="select"
                                                name="married"
                                                id="settlementAgreementStatus"
                                                onChange={(e) => setJudgeThirdteen(e.target.value)}
                                            >
                                                <option selected value="-1">
                                                    {" "}
                                                    -- Select an option --{" "}
                                                </option>
                                                <option value={0} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus == 0}> No</option>
                                                <option value={1} selected={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus == 1}> Yes</option>
                                            </Input>
                                        </FormGroup>
                                    </div>
                                    <Collapse isOpen={isJudgeThirdteen == 0 ? true : false}>
                                        <FormGroup>
                                            <h5>Do you want ? </h5>
                                            <Input
                                                defaultValue={props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementNo.legalProfessionalStatus}
                                                type="select"
                                                name="married"
                                                id="legalProfessionalStatus"
                                                onChange={(e) => setLegalProfessional(e.target.value)}
                                            >
                                                <option selected value="-1">
                                                    {" "}
                                                    -- Select an option --{" "}
                                                </option>
                                                <option value={0} >Start interview over</option>
                                                <option value={1}> Exit interview</option>
                                            </Input>
                                        </FormGroup>
                                    </Collapse>
                                    <Collapse isOpen={isJudgeThirdteen == 1 ? true : false}>
                                        <FormGroup>
                                            <Alert style={{
                                                backgroundColor: "yellow",
                                                color: "black"
                                            }} icon={false} severity="warning">Please, complete the FL-165 and follow the instructions in the tutorials to Request a Default. Your Default is known as a “Default By Agreement. </Alert>
                                        </FormGroup>
                                    </Collapse>
                                </Collapse>
                            </Collapse>
                        </Collapse>
                    </div>

                );
            case 2:
                return (
                    <div>
                        <FormGroup>
                            <Label for="finalDeclarations">Are you waiving the Final Declarations of Disclosure?</Label>
                            <Input
                                defaultValue={
                                    props.isFinalDeclarations
                                }
                                type="select"
                                name="finalDeclarations"
                                id="finalDeclarations"
                            >
                                <option selected value="-1">
                                    {" "}
                                    -- select an option --{" "}
                                </option>
                                <option value={0}>No</option>
                                <option value={1}> Yes </option>
                            </Input>
                        </FormGroup>
                    </div>
                );
            case 3:
                return (
                    <div>
                        {/* Q5 Started */}
                        <FormGroup>
                            <h5></h5>
                            <Label for="amendPetition"></Label>
                            <Input
                                defaultValue={props.isAmendPetition}
                                type="select"
                                name="amendPetition"
                                id="amendPetition"
                            >
                                <option selected value="-1">
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value={0}>No </option>
                                <option value={1}> Yes </option>
                            </Input>
                        </FormGroup>
                    </div>
                );
            case 4:
                return (
                    <div>
                        {/* Q6 Started */}
                        <div style={{ margin: "30px 0px" }}>
                            <FormGroup>
                                <h5>Select which event happened first:</h5>
                                <Input
                                    defaultValue={props.whatEventHappnedFirst.eventHappnedFirstStatus}
                                    type="select"
                                    name="married"
                                    id="eventStatus"
                                    onChange={(e) => setJudgeFour(e.target.value)}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value="0">Respondent was served with the Petition Packet. </option>
                                    <option value="1"> Respondent made an appearance. [Filed Response Packet first before being served]   </option>
                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isJudgeFour == 0}>
                            <FormGroup>
                                <h5>What date was the Respondent served? </h5>
                                <Label for="respondentServedDate"></Label>
                                <Input
                                    defaultValue={props.whatEventHappnedFirst.respondentServed.respondentServedDate == '1947-01-01' ? "" : moment(props.whatEventHappnedFirst.respondentServed.respondentServedDate).isValid() && moment(props.whatEventHappnedFirst.respondentServed.respondentServedDate).format('YYYY-MM-DD')}

                                    type="date"
                                    name="respondentServedDate"
                                    id="respondentServedDate"
                                >

                                </Input>
                            </FormGroup>
                        </Collapse>
                        <Collapse isOpen={isJudgeFour == 1}>
                            <FormGroup>
                                <h5> What date did the Respondent appear?</h5>
                                <Label for="respondentAppearsDate"></Label>
                                <Input
                                    defaultValue={props.whatEventHappnedFirst.respondentAppears.respondentAppearenceDate == '1947-01-01' ? "" : moment(props.whatEventHappnedFirst.respondentAppears.respondentAppearenceDate).format('YYYY-MM-DD')}

                                    type="date"
                                    name="respondentAppearsDate"
                                    id="respondentAppearsDate"
                                >

                                </Input>
                            </FormGroup>
                        </Collapse>
                    </div>
                );
            case 5:
                return (
                    <div>
                        {/* Q7 Started */}
                        <FormGroup>
                            <Label for="filingStatus"></Label>
                            <Input
                                defaultValue={
                                    props.whichFilingOption
                                }
                                type="select"
                                name="filingStatus"
                                id="filingStatus"
                                onChange={(e) => setFilling(e.target.value)}

                            >
                                <option selected value="-1">
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value={0}>Divorce/Dissolution of Marriage </option>
                                <option value={1}>Legal Separation  </option>
                                <option value={2}>Nullity of marriage   </option>
                            </Input>
                        </FormGroup>
                    </div>
                );
            case 6:
                return (
                    <div>
                        {/* Q8 Started */}
                        <div style={{
                            fontStyle: "normal",
                            fontFamily: "sans-serif",
                            backgroundColor: "white",
                            textAlign: "justify",
                            textJustify: "inter-word",
                            paddingTop: "10px"
                        }}
                        >
                            <FormGroup>
                                <label>Your marital status will dissolve on one of the following 3 options:</label>
                                <ol>
                                    <li><p><strong>6 months & 1 day </strong>from when Petition was served or later.</p>
                                        <p> You can select this option if your final agreement will be filed with the court before the 6 months has elapsed. If your county is taking time to file agreements, keep this in mind as you may not have your Judgment entered in time.</p>
                                        <p> <strong>How to Determine the Date.</strong></p>

                                        <p>Example 1: Respondent signed the Notice of Acknowledgment of Receipt, FL-117, on April 1st. Status would dissolve on October 2nd.</p>

                                        <p>Example 2: Petitioner had Respondent personally served on July 16th. Status would dissolve on January 17th of the following year.</p>

                                    </li>
                                    <li> <p><strong>Date your Judgment is Filed </strong> with the court if the 6 months has already lapsed/would be lapsed.</p> </li>
                                    <li><p><strong>You Select a Date in the Future.</strong>  (See the video tutorials for more).</p></li>
                                </ol>

                            </FormGroup>
                        </div>
                        <FormGroup>
                            <Label for="dissolveMarriageStatus"></Label>
                            <Input
                                defaultValue={
                                    props.isDissolveMarriage.dissolveMarriageStatus
                                }
                                type="select"
                                name="dissolveMarriageStatus"
                                id="dissolveMarriageStatus"
                                onChange={(e) => setJudgeFive(e.target.value)}
                            >
                                <option selected value="-1">
                                    {" "}
                                    -- Select an option --{" "}
                                </option>
                                <option value={0}>6 months & 1 day from when the Petition was served/or Respondent appeared.</option>
                                <option value={1}> Date your Judgment is Filed </option>
                                <option value={2}>  Future Date </option>
                            </Input>
                        </FormGroup>
                        <Collapse isOpen={isJudgeFive == 0 || isJudgeFive == 1 || isJudgeFive == 2 ? true : false}>
                            <FormGroup>
                                <h5> Please enter the date: </h5>
                                <Label for="sixMonthDate"></Label>
                                <Input
                                    defaultValue={props.isDissolveMarriage.sixMonth.sixMonthDate === '1947-01-01' ? moment(Date.now()).format('YYYY-MM-DD') : moment(props.isDissolveMarriage.sixMonth.sixMonthDate).isValid() && moment(props.isDissolveMarriage.sixMonth.sixMonthDate).format('YYYY-MM-DD')}
                                    type="date"
                                    name="sixMonthDate"
                                    id="sixMonthDate"
                                >
                                </Input>
                            </FormGroup>
                        </Collapse>

                    </div>
                );
            case 7:
                return (
                    <div>
                        {/* Q9 Started */}
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="exampleSelect"></Label>
                                <Input
                                    defaultValue={props.haveMinorChildren}
                                    type="select"
                                    name="married"
                                    id="minor_children_agreement"
                                    onChange={(e) => setJudgeSix(e.target.value)}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value={0}>No </option>
                                    <option value={1}>Yes </option>

                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isJudgeSix == 1 ? true : false}>
                            <div style={{ marginBottom: "20px", padding: "0 15px" }}>
                                <FormGroup>

                                    <h5> Your children’s names and birthdates?</h5>
                                    <div style={{ margin: "15px 0", padding: "0 30px" }}>
                                        <Row>
                                            <Col lg="6">
                                                <p><b> Name </b></p>
                                            </Col>
                                            <Col lg="6">
                                                <p><b> Birth Date</b></p>
                                            </Col>
                                        </Row>
                                        {!isEmpty(props.underAge18Child.yes.childInfo) && props.underAge18Child.yes.childInfo.map((eachChild) =>
                                            <Row>
                                                <Col lg="6">
                                                    <p>
                                                        {eachChild.first_name} {eachChild.last_name}
                                                    </p>
                                                </Col>
                                                <Col lg="6">
                                                    <p>
                                                        {eachChild.dob}
                                                    </p>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>
                                </FormGroup>
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <h5> Were any of your children in this relationship born prior to your marriage?</h5>
                                    <Input
                                        type="select"
                                        name="married"
                                        id="prior_mirrage"
                                        onChange={(e) => setJudgeSeven(e.target.value)}
                                        defaultValue={props.bornPriorMarriage.childBornBeforeStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>No </option>
                                        <option value={1}>Yes </option>

                                    </Input>
                                </FormGroup>
                            </div>

                            <Collapse isOpen={isJudgeSeven == 1 ? true : false}>
                                <FormGroup>
                                    <Label for="exampleSelect"><b>Please select and complete one of the following:</b></Label>
                                    <Input
                                        type="select"
                                        name="married"
                                        id="selectAndComplete"
                                        onChange={(e) => setJudgeEight(e.target.value)}
                                        defaultValue={props.bornPriorMarriage.completeOneStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>A voluntary declaration of parentage or paternity will be attached to your FL-170. </option>
                                        <option value={1}> Parentage was previously established by the court in </option>
                                        <option value={2}>  Our written agreement regarding parentage will be attached to our FL-170 (Attachment 9b.) or to the FL-180, Judgment.</option>
                                    </Input>
                                </FormGroup>
                                <Collapse isOpen={isJudgeEight == 1 ? true : false}>
                                    <div style={{ marginBottom: "30px" }}>
                                        <FormGroup>
                                            <Row>
                                                <Col lg="6">
                                                    <Label for="exampleSelect">County:</Label>
                                                    <Input
                                                        type="text"
                                                        name="married"
                                                        id="selectAndCompleteCounty"
                                                        defaultValue={props.bornPriorMarriage.percentagePrevoiuslySet.county}
                                                    >
                                                    </Input>
                                                </Col>
                                                <Col lg="6">
                                                    <Label for="exampleSelect">Case Number:</Label>
                                                    <Input
                                                        type="text"
                                                        name="married"
                                                        id="selectAndCompleteCase"
                                                        defaultValue={props.bornPriorMarriage.percentagePrevoiuslySet.caseNumber}
                                                    >
                                                    </Input>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </div>
                                </Collapse>
                            </Collapse>

                            <Collapse isOpen={isJudgeSeven == 0 ? true : false}>
                                <div style={{ marginBottom: "30px" }}>
                                    <FormGroup>
                                        <Label for="exampleSelect"> Did any of the information you entered in the UCCJEA, FL-105, change?</Label>
                                        <Input
                                            type="select"
                                            name="married"
                                            id="UCCJEA"
                                            onChange={(e) => setAnyInfo(e.target.value)}
                                            defaultValue={props.bornPriorMarriage.childBornBeforeNo.ChangeInFL_105Status}
                                        >
                                            <option selected value="-1">
                                                {" "}
                                                -- Select an option --{" "}
                                            </option>
                                            <option value={0}>No </option>
                                            <option value={1}>Yes </option>

                                        </Input>
                                    </FormGroup>
                                </div>
                            </Collapse>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <h5>Is there an existing court order for custody/parenting time in another case?</h5>
                                    <Input
                                        type="select"
                                        name="married"
                                        id="existingCourtOrder"
                                        onChange={(e) => setJudge(e.target.value)}
                                        defaultValue={props.existingCourtOrder.courtCustodyCaseStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>No </option>
                                        <option value={1}>Yes </option>

                                    </Input>
                                </FormGroup>
                            </div>
                            <Collapse isOpen={isJudge == 1 ? true : false}>
                                <div style={{ marginBottom: "30px" }}>
                                    <FormGroup>
                                        <Row>
                                            <Col lg="4">
                                                <Label for="exampleSelect"> Which court ?</Label>
                                                <Input
                                                    type="text"
                                                    name="married"
                                                    id="existingCourtOrderCourt"
                                                    defaultValue={props.existingCourtOrder.courtCustodyCaseYes.court}
                                                >
                                                </Input>
                                            </Col>
                                            <Col lg="4">
                                                <Label for="exampleSelect">Which county ?</Label>
                                                <Input
                                                    type="text"
                                                    name="married"
                                                    id="existingCourtOrderCounty"
                                                    defaultValue={props.existingCourtOrder.courtCustodyCaseYes.county}
                                                >
                                                </Input>
                                            </Col>
                                            <Col lg="4">
                                                <Label for="exampleSelect">What case number ?</Label>
                                                <Input

                                                    type="text"
                                                    name="married"
                                                    id="existingCourtOrderCase"
                                                    defaultValue={props.existingCourtOrder.courtCustodyCaseYes.caseNumber}
                                                >
                                                </Input>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </div>
                            </Collapse>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <h5> Is child support being enforced in another case? </h5>
                                    <Input

                                        type="select"
                                        name="married"
                                        id="childSupportEnforced"
                                        onChange={(e) => setJudgeNine(e.target.value)}
                                        defaultValue={props.childEnforced.enforcedInOtherCaseStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>No </option>
                                        <option value={1}>Yes </option>

                                    </Input>
                                </FormGroup>
                                <Collapse isOpen={isJudgeNine == 1 ? true : false}>
                                    <div style={{ marginBottom: "30px" }}>
                                        <FormGroup>
                                            <Row>
                                                <Col lg="4">
                                                    <Label for="exampleSelect"> Which court ?</Label>
                                                    <Input

                                                        type="text"
                                                        name="married"
                                                        id="childSupportEnforcedCourt"
                                                        defaultValue={props.childEnforced.enforcedInOtherCaseYes.court}
                                                    >
                                                    </Input>
                                                </Col>
                                                <Col lg="4">
                                                    <Label for="exampleSelect">Which county ?</Label>
                                                    <Input

                                                        type="text"
                                                        name="married"
                                                        id="childSupportEnforcedCounty"
                                                        defaultValue={props.childEnforced.enforcedInOtherCaseYes.county}
                                                    >
                                                    </Input>
                                                </Col>
                                                <Col lg="4">
                                                    <Label for="exampleSelect">What case number ?</Label>
                                                    <Input

                                                        type="text"
                                                        name="married"
                                                        id="childSupportEnforcedCase"
                                                        defaultValue={props.childEnforced.enforcedInOtherCaseYes.caseNumber}
                                                    >
                                                    </Input>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </div>
                                </Collapse>
                                <Collapse isOpen={isJudgeNine == 0 ? true : false}>

                                    <FormGroup>
                                        <Label for="exampleSelect">Please select one ?</Label>
                                        <Input

                                            type="select"
                                            name="married"
                                            id="select_one"
                                            onChange={(e) => setJudgeTen(e.target.value)}
                                            defaultValue={props.childEnforced.enforcedInOtherCaseNo.selectionStatus}
                                        >
                                            <option selected value="-1">
                                                {" "}
                                                -- Select an option --{" "}
                                            </option>
                                            <option value={0}>I am providing a child support calculation as part of my Judgment packet and it is correct based on my personal knowledge.</option>
                                            <option value={1}>I want to have child support based on my spouse’s earning ability.  [This option is uncommon].</option>
                                        </Input>
                                    </FormGroup>

                                    <Collapse isOpen={isJudgeTen == 1 ? true : false}>
                                        <FormGroup>
                                            <Label for="exampleSelect"> Your spouse is </Label>
                                            <Input

                                                type="select"
                                                name="married"
                                                id="your_spouse"
                                                onChange={(e) => setSpouse(e.target.value)}
                                                defaultValue={props.childEnforced.enforcedInOtherCaseNo.selectionNo.spouseStatus}
                                            >
                                                <option selected value="-1">
                                                    {" "}
                                                    -- Select an option --{" "}
                                                </option>
                                                <option value={0}>Petitioner </option>
                                                <option value={1}>Respondent</option>
                                            </Input>
                                        </FormGroup>
                                        <div style={{ marginBottom: "30px" }}>
                                            <FormGroup>
                                                <Label for="exampleSelect">Please provide the facts that support your estimate of your spouse’s earning ability:</Label>
                                                <Input

                                                    type="text"
                                                    name="married"
                                                    id="spouse_earning_ability"
                                                    defaultValue={props.childEnforced.enforcedInOtherCaseNo.selectionNo.provideFacts}
                                                >
                                                </Input>
                                            </FormGroup>
                                        </div>
                                    </Collapse>
                                </Collapse>
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <h5><b>Complete items the following regarding public assistance.</b>  </h5>

                                    <br />
                                    <Label for="exampleSelect">Are you receiving public assistance for the child or children listed in the settlement agreement.</Label>
                                    <Input

                                        type="select"
                                        name="married"
                                        id="public_assistance"
                                        onChange={(e) => setPublicAssistance(e.target.value)}
                                        defaultValue={props.publicAssitance.publicAssitanceFirstStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>I am receiving </option>
                                        <option value={1}>I am not receiving </option>
                                        <option value={2}>Intend to apply  </option>
                                    </Input>
                                </FormGroup>
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect">To the best of my knowledge, the other party is</Label>
                                    <Input

                                        type="select"
                                        name="married"
                                        id="best_my_knowledge"
                                        onChange={(e) => setJudgeFourteen(e.target.value)}
                                        defaultValue={props.publicAssitance.publicAssitanceSecondStatus}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}> Is receiving public assistance.</option>
                                        <option value={1}>Is not receiving public assistance.</option>

                                    </Input>
                                </FormGroup></div>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <Label for="exampleSelect"> The party receiving public assistance is</Label>

                                    <Input

                                        type="select"
                                        name="married"
                                        id="party_receiving"
                                        onChange={(e) => setJudgeFiveteen(e.target.value)}
                                        defaultValue={props.publicAssitance.publicAssitanceThird}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>Petitioner </option>
                                        <option value={1}>Respondent</option>

                                    </Input>
                                </FormGroup>
                            </div>

                        </Collapse>
                    </div>
                );
            case 8:
                return (
                    <div>
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Label for="changeFormerNameStatus"></Label>
                                <Input
                                    defaultValue={
                                        props.isChangeFormerName.changeFormerNameStatus
                                    }
                                    type="select"
                                    name="changeFormerNameStatus"
                                    id="changeFormerNameStatus"
                                    onChange={(e) => setJudgeTwelve(e.target.value)}
                                >
                                    <option selected value="-1">
                                        {" "}
                                        -- Select an option --{" "}
                                    </option>
                                    <option value={0}>No </option>
                                    <option value={1}>Yes </option>

                                </Input>
                            </FormGroup>
                        </div>
                        <Collapse isOpen={isJudgeTwelve == 1 ? true : false}>
                            <div style={{ marginBottom: "30px" }}>
                                <FormGroup>
                                    <h5> </h5>
                                    <Label for="isSpouseStatus"> Which spouse wants to change their name? </Label>
                                    <Input
                                        defaultValue={
                                            props.isChangeFormerName.changeFormerNameYes.isSpouseStatus
                                        }
                                        type="select"
                                        name="isSpouseStatus"
                                        id="isSpouseStatus"
                                        onChange={(e) => setJudgeNineteen(e.target.value)}
                                    >
                                        <option selected value="-1">
                                            {" "}
                                            -- Select an option --{" "}
                                        </option>
                                        <option value={0}>Petitioner </option>
                                        <option value={1}>Respondent</option>
                                    </Input>
                                </FormGroup>
                            </div>

                            <FormGroup>
                                <Label for="formerLastName">What name?</Label>
                                <Input
                                    defaultValue={
                                        props.isChangeFormerName.changeFormerNameYes.name
                                    }
                                    type="text"
                                    name="formerLastName"
                                    id="formerLastName"
                                >
                                </Input>
                            </FormGroup>
                        </Collapse>
                    </div>
                );
            case 9:
                return (
                    <div>
                        <div style={{ marginBottom: "30px" }}>
                            <FormGroup>
                                <Col lg="6">
                                    <Label for="exampleSelect">Number of pages attached</Label>
                                    <Input
                                        min={"0"}
                                        max={"99"}
                                        type="number"
                                        name="pagesAttached"
                                        id="pagesAttached"
                                        // value={pageNumber}
                                        defaultValue={props.number_pages_attached}
                                    >
                                    </Input>
                                </Col>
                            </FormGroup>
                        </div>
                    </div>
                );
            default:
                return 'Unknown step';
        }
    }


    const handleNext = () => {
        handlePostFunc();
        setActiveStep((prevActiveStep) => prevActiveStep + 1)


    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (props.whichFilingOption == 1 && prevActiveStep == 7) ? prevActiveStep - 2 :
            (props.whichFilingOption == 2 && prevActiveStep == 7) ? prevActiveStep - 2 :
                prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        props.isFetchingGetJugdementFormDataState
            ? <div className={classes.root}>
                <div style={{ marginLeft: "42%", marginTop: "18%" }}>
                    <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={120}
                        width={120}
                    />
                </div>
            </div> :
            <div className={classes.root}>
                <div style={{
                    fontStyle: "normal",
                    fontFamily: "sans-serif",
                    backgroundColor: "white",
                    textAlign: "justify",
                    textJustify: "inter-word",
                    padding: "20px",
                    padding: "30px 70px",
                }}
                >
                    <FormGroup>
                        <h3 style={{ paddingBottom: "5px", fontStyle: "normal", fontWeight: "bolder", fontFamily: "sans-serif", color: "#00BBBB", textAlign: "center" }}>IMPORTANT: PLEASE READ!</h3>
                        <p>
                            This Interview will assist you to complete the Judicial Council forms required to receive a Divorce Judgment. Please carefully review your course materials, videos, checklists and flowcharts before proceeding.</p>
                        <ul>
                            <li>The form builder will work for uncontested cases. <b>This builder is NOT intended for contested cases or defaults.</b>
                                <ul>
                                    <li>We suggest that the Respondent file a Response or appear using the Stipulation for Appearances, FL-130, and mark 1.a. </li>
                                    <li>Respondents must either pay their filing fee or receive a fee waiver. </li>
                                    <li>Why? This prevents a true default. It also makes sure both parties prepare and complete their disclosures.</li>
                                </ul>  </li>
                            <li>We also are assuming you will use a written agreement and not the JC forms. (You can easily change the selections after you download your forms if you want to use JC forms instead of the MSA).</li>
                            <li>You can do this interview and the MSA builder interview in any order.</li>
                            <li>Prior to this final step, you and your spouse must have completed and exchanged a Preliminary Declaration of Disclosure. We assume you have completed this prior to answering these interview questions.<b> If you did not, stop and go back to Step 2.</b></li>
                            <li>Use your checklist and flowchart for instructions on how to package your Judgment Packet and MSA and file it with the court clerk.</li>
                        </ul>
                    </FormGroup>
                </div>
                <Stepper activeStep={activeStep} orientation="vertical"
                    style={{

                        fontStyle: "normal",
                        fontFamily: "sans-serif",
                        backgroundColor: "white",
                        textAlign: "justify",
                        textJustify: "inter-word",
                        padding: "30px 70px"
                    }}
                >
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            <StepContent>
                                <Typography>{getStepContent(index)}</Typography>
                                <div className={classes.actionsContainer}>
                                    <div>
                                        <Button
                                            disabled={activeStep == 0}
                                            onClick={handleBack}
                                            className={classes.button}
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleNext}
                                            className={classes.button}
                                        >
                                            {activeStep == steps.length - 1 ? 'Finish' : 'Next'}
                                        </Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
                {activeStep == steps.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Typography>All steps completed - you&apos;re finished</Typography>
                        <div>
                            <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                                Reset
                            </Button>
                            <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                                Back
                            </Button>
                        </div>
                    </Paper>
                )}
                <div style={{ display: "flex", float: "right" }}>
                    {props.isSpouseMilitaryMember == 1 ?
                        <Button
                            style={{ marginRight: "1px" }}
                            variant="contained"
                            color="primary"
                            onClick={printFL130A}
                        >
                            Print FL 130(A)
                        </Button> : ""}

                    {props.isFinalDeclarations == 1 ?
                        <Button
                            style={{ marginRight: "1px" }}
                            variant="contained"
                            color="primary"
                            onClick={printFL144}
                        >
                            Print FL 144
                        </Button> : ""}

                    {(props.IsRespondentAppears.respondentAppearsStatus == 0 && props.IsRespondentAppears.respondentAppearsNo.divorcePurposeStatus == 0 && props.IsRespondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewStatus == 0) ? "" :
                        <Button
                            style={{ marginRight: "1px" }}
                            variant="contained"
                            color="primary"
                            onClick={printFL130}
                        >
                            Print FL 130
                        </Button>
                    }
                    <Button
                        style={{ marginRight: "1px" }}
                        variant="contained"
                        color="primary"
                        onClick={printFL170}
                    >
                        Print FL 170
                    </Button>
                    <Button
                        style={{ marginRight: "1px" }}
                        variant="contained"
                        color="primary"
                        onClick={printFL180}
                    >
                        Print FL 180
                    </Button>
                    <Button
                        style={{ marginRight: "1px" }}
                        variant="contained"
                        color="primary"
                        onClick={printFL190}
                    >
                        Print FL 190
                    </Button>
                </div>

                <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>
                    <ModalBody><b>Warning:</b>If Respondent does not “appear,” Respondent will not be required to provide you his/her disclosure documents. Some choose this option to avoid paying the second court filing fee. We do not recommend this method. If no appearance is made, then you are completing a Default with Agreement or True Default divorce. You will need to do the FL-165, separately, and follow the steps in the flowchart.The form builder is not intended for a true default. You can still use the form builder for a default if the Respondent will sign a settlement agreement (MSA). You will need to do the FL-165 and follow the steps in the flowchart.</ModalBody>
                    <Button
                        style={{ width: "", color: "black", backgroundColor: "yellow" }}
                        onClick={handleClose}
                    >
                        <b>Close</b>
                    </Button>
                </Modal>
            </div>
    );

};

const mapDispatchToProps = (dispatch) => {
    return {
        postJudgementForm: (data) => dispatch(postJudgementForm(data)),
        petitionerCheck: (data) => dispatch(petitionerCheck(data)),
        isMilitaryMember: (data) => dispatch(isMilitaryMember(data)),
        numberPagesAttached: (data) => dispatch(numberPagesAttached(data)),
        finalDeclarationsWaive: (data) => dispatch(finalDeclarationsWaive(data)),
        amendPetition: (data) => dispatch(amendPetition(data)),
        eventHappened: (data) => dispatch(eventHappened(data)),
        filingCompeleting: (data) => dispatch(filingCompeleting(data)),
        dissolvingMarriage: (data) => dispatch(dissolvingMarriage(data)),
        respondentAppears: (data) => dispatch(respondentAppears(data)),
        haveSpousalSupport: (data) => dispatch(haveSpousalSupport(data)),
        changeFormerName: (data) => dispatch(changeFormerName(data)),
        getJudgementFormData: (data) => dispatch(getJudgementFormData(data)),
        getStates: () => dispatch(getStates()),
        getFormData: (data) => dispatch(getFormData(data)),
        petitionerGetAllData: () => dispatch(petitionerGetAllData()),
        haveMinorChild: (data) => dispatch(haveMinorChild(data)),


    };
};
const mapStateToProps = (state, ownProps) => ({
    isPetitioner: state.JudgementPacketFormsReducer.areYouPetitioner,
    isSpouseMilitaryMember: state.JudgementPacketFormsReducer.spouseMilitaryMember,
    IsRespondentAppears: state.JudgementPacketFormsReducer.respondentAppears,
    isFinalDeclarations: state.JudgementPacketFormsReducer.finalDeclarations,
    isAmendPetition: state.JudgementPacketFormsReducer.amendPetition,
    whatEventHappnedFirst: state.JudgementPacketFormsReducer.eventHappnedFirst,
    whichFilingOption: state.JudgementPacketFormsReducer.whichFiling,
    isDissolveMarriage: state.JudgementPacketFormsReducer.dissolveMarriage,
    IsspousalSupportMSA: state.JudgementPacketFormsReducer.spousalSupportMSA,
    isChangeFormerName: state.JudgementPacketFormsReducer.changeFormerName,
    petitioner: state.ProfileInformationReducer.petitionerDetails,
    respondent: state.ProfileInformationReducer.respondentDetails,
    court: state.ProfileInformationReducer.court,
    states: state.ProfileInformationReducer.states,
    isFetchingStates: state.ProfileInformationReducer.isFetchingStates,
    profilePetitionerCheck: state.ProfileInformationReducer.petitionerCheck,
    filedPetition: state.petitionerPacketReducer.filedPetition,
    isFetchingGetJugdementFormDataState: state.JudgementPacketFormsReducer.isFetchingGetJugdementFormData,
    underAge18Child: state.ChildInformationReducer.underAge18,

    haveMinorChildren: state.JudgementPacketFormsReducer.minorChildAgreement.minorChildStatus,
    bornPriorMarriage: state.JudgementPacketFormsReducer.minorChildAgreement.childBornBefore,
    existingCourtOrder: state.JudgementPacketFormsReducer.minorChildAgreement.courtCustodyCase,
    childEnforced: state.JudgementPacketFormsReducer.minorChildAgreement.enforcedInOtherCase,
    publicAssitance: state.JudgementPacketFormsReducer.minorChildAgreement.publicAssitance,

    number_pages_attached: state.JudgementPacketFormsReducer.number_pages_attached

});

export default connect(mapStateToProps, mapDispatchToProps)(JudgmentPacketForms);
